// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2Kr8R","halfWidth":"style_halfWidth__38QiK","hasLeftBorder":"style_hasLeftBorder__1p5Gr"};